import { ValidFieldTypes } from '../types';

export enum EPaymentMethod {
  PAY_WITH_CREDIT_CARD = 'credit',
  ACH_ELECTRONIC_CHECK = 'ach',
}

export enum ECardType {
  VISA = 'Visa',
  DISCOVER = 'Discover',
  MASTERCARD = 'MasterCard',
  AMEX = 'Amex',
  JCB = 'Jcb',
  PREDEFINED = 'Predefined',
}

export const PayRequestDataFromFields = {
  [ValidFieldTypes.CARD_NUMBER]: 'Pan',
  [ValidFieldTypes.EXPIRATION_DATE]: 'Expiration',
  [ValidFieldTypes.CVV]: 'Cvv',
  [ValidFieldTypes.ROUTING]: 'Aba',
  [ValidFieldTypes.ACCOUNT_NUMBER]: 'Dda',
};
